import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { failed: boolean; isChunkError: boolean }

export class FeatureBoundary extends Component<Props, State> {
  state: State = { failed: false, isChunkError: false }

  static getDerivedStateFromError(error: Error): State {
    const isChunkError = /Failed to fetch dynamically imported module|Importing a module script failed/i.test(error?.message || '')
    return { failed: true, isChunkError }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Feature render failed', error, info)
    const isChunkError = /Failed to fetch dynamically imported module|Importing a module script failed/i.test(error?.message || '')
    if (isChunkError) {
      const reloadKey = `chunk_reload_${window.location.pathname}`
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1')
        window.location.reload()
      }
    }
  }

  render() {
    if (this.state.failed) {
      return (
        <section className="access-denied">
          <h1>Không thể tải trang</h1>
          <p className="mt-2 text-sm text-slate-500">
            {this.state.isChunkError
              ? 'Hệ thống vừa cập nhật phiên bản mới. Vui lòng tải lại trang để áp dụng.'
              : 'Đã xảy ra lỗi khi tải tính năng.'}
          </p>
          <button className="secondary-button mt-4" onClick={() => window.location.reload()}>
            Tải lại trang
          </button>
        </section>
      )
    }
    return this.props.children
  }
}
